<template>
    <v-tabs :value="value" centered show-arrows center-active class="tab tab--inline tab--underline-inline">
        <v-tab v-for="group in groups" :key="group.text" v-bind="group" exact-path>
            <span>{{ group.text }}</span>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    props: ["value", "program"],
    computed: {
        groups() {
            return [{ text: "전체", to: `/auction-programs/${this.program?._id}/groups/all` }, ...(this.program?.groups || []).map((text) => ({ text, to: `/auction-programs/${this.program?._id}/groups/${text}` }))];
        },
    },
};
</script>

<style></style>
